import React, { FunctionComponent } from 'react';
import { IBlog } from '../../../@types/generated/contentful';

import BlogPostTile from '../blogPostTile'

type Props = {
    relatedPosts?: IBlog[]|null
};

const BlogRelatedPosts: FunctionComponent<Props> = ({ relatedPosts }) => {

    if (relatedPosts?.length === 0) return <></>

    return (
        <div>
            <h2 className='bullet-sub-heading'>Related posts</h2>
            {
                relatedPosts?.map((post) => {
                    return (
                        <BlogPostTile
                            key={post.sys.id}
                            title={post.fields.title}
                            image={post.fields.image}
                            slug={post.fields.slug}
                            date={post.fields.date}
                        />
                    )
                })
                
            }
        </div>
    );
};

export default BlogRelatedPosts;